module.exports = __webpack_public_path__ + "static/img/30.2afebcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/30.png
// module id = 3Pmq
// module chunks = 1